export default __webpack_public_path__ + "static/media/Avatar-5.2ad0a40b.svg";